import {
    SET_BET_SLIP_VIEW,
    SET_FULL_VIEW_PLAYER,
    SET_HAS_TOUCH_SCREEN,
    SET_SHOW_VIRTUAL_KEYBOARD,
    SET_VIDEO_MUTED,
    SET_VIDEO_VISIBILITY,
    SET_VIEW_MODE,
    TOGGLE_UNREAD_BETS_NOTIFICATION
} from '../constants/actionTypes';

export default (state, action) => {
    switch (action.type) {
        case SET_VIEW_MODE:
            return {
                ...state,
                isDesktopMode: action.isDesktopMode
            };
        case SET_HAS_TOUCH_SCREEN:
            return {
                ...state,
                hasTouchScreen: action.hasTouchScreen
            };
        case SET_SHOW_VIRTUAL_KEYBOARD:
            return {
                ...state,
                showVirtualKeyboard: action.showVirtualKeyboard
            };
        case SET_FULL_VIEW_PLAYER:
            return {
                ...state,
                isInFullViewPlayer: action.isInFullViewPlayer
            };
        case SET_VIDEO_VISIBILITY:
            return {
                ...state,
                isVideoVisible: action.isVideoVisible
            };
        case TOGGLE_UNREAD_BETS_NOTIFICATION:
            let newIsUnreadBetsNotificationToggled = !state.isUnreadBetsNotificationToggled;
            return {
                ...state,
                isUnreadBetsNotificationToggled: newIsUnreadBetsNotificationToggled
            }
        case SET_VIDEO_MUTED:

            return {
                ...state,
                isVideoMuted: action.isVideoMuted
            }
        case SET_BET_SLIP_VIEW:
            return {
                ...state,
                isBetSlipSideView: action.isBetSlipSideView
            }

        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/reducers/systemReducer.js